import { useEffect, useState } from "react";
import { NetworkFetch } from "../network/networkFetch";
import { apiRoutes } from "../network/apiRoutes";

export const usePlans = (serviceId?: string) => {
  const [plans, setPlans] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPlans = async () => {
      if (!serviceId) {
        setPlans([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await NetworkFetch(apiRoutes.getPlans, { serviceId });

        if (response && Array.isArray(response)) {
          setPlans(response);
        } else if (response?.data && Array.isArray(response.data)) {
          setPlans(response.data);
        } else {
          setPlans([]);
        }
        setError(null);
      } catch (err) {
        console.error("Error fetching plans:", err);
        setError(err instanceof Error ? err.message : "Error al cargar planes");
        setPlans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, [serviceId]);

  return { plans, loading, error };
};
